export interface DeliverableInterface {
  fileName: string;
  fileType: string;
  fileSizeInBytes: number;
  mediaUrl?: string;
}

export interface DeliveryMetaInterface {
  buyerId: string;
  sellerId: string;
  gigId: string;
  channelId: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface DeliveryInterface {
  id: string;
  metaData: DeliveryMetaInterface;
  previewScreenshots?: string[];
  remarks?: string;
  order: string;
  deliverables: DeliverableInterface[];
  createdAt?: Date;
  updatedAt?: Date;
}

export class Deliverable implements DeliverableInterface {
  fileName: string;
  fileType: string;
  fileSizeInBytes: number;
  mediaUrl?: string;

  constructor(jsonData: any) {
    this.fileName = jsonData.fileName;
    this.fileType = jsonData.fileType;
    this.fileSizeInBytes = jsonData.fileSizeInBytes;
    this.mediaUrl = jsonData.mediaUrl;
  }
}

export class DeliveryMeta implements DeliveryMetaInterface {
  buyerId: string;
  sellerId: string;
  gigId: string;
  channelId: string;
  createdAt?: Date;
  updatedAt?: Date;

  constructor(jsonData: any) {
    this.buyerId = jsonData.buyerId;
    this.sellerId = jsonData.sellerId;
    this.gigId = jsonData.gigId;
    this.channelId = jsonData.channelId;
    this.createdAt = jsonData.createdAt ? new Date(jsonData.createdAt) : undefined;
    this.updatedAt = jsonData.updatedAt ? new Date(jsonData.updatedAt) : undefined;
  }
}

export class Delivery implements DeliveryInterface {
  id: string;
  metaData: DeliveryMetaInterface;
  previewScreenshots?: string[];
  remarks?: string;
  order: string;
  deliverables: DeliverableInterface[];
  createdAt?: Date;
  updatedAt?: Date;

  constructor(jsonData: any) {
    this.id = jsonData._id;
    this.metaData = new DeliveryMeta(jsonData.metaData);
    this.previewScreenshots = Array.isArray(jsonData?.previewScreenshots)
      ? jsonData.previewScreenshots.filter((url: unknown): url is string => typeof url === 'string')
      : [];
    this.remarks = jsonData.remarks;
    this.order = jsonData.order;
    this.deliverables = Array.isArray(jsonData?.deliverables)
      ? jsonData.deliverables.filter(Boolean).map((del: any) => new Deliverable(del))
      : [];
    this.createdAt = jsonData.createdAt ? new Date(jsonData.createdAt) : undefined;
    this.updatedAt = jsonData.updatedAt ? new Date(jsonData.updatedAt) : undefined;
  }
}
